import React from "react";
import useSEO from "../hooks/useSEO";
import Hero from "../components/home/Hero";
import Stats from "../components/home/Stats";
import Services from "../components/home/Services";
import WhyChoose from "../components/home/WhyChoose";
import TechStack from "../components/home/TechStack";
import Process from "../components/home/Process";
import Industries from "../components/home/Industries";
import Work from "../components/home/Work";
import AISpotlight from "../components/home/AISpotlight";
import Leadership from "../components/home/Leadership";
import Testimonials from "../components/home/Testimonials";
import ContactCTA from "../components/home/ContactCTA";

export default function Home() {
  useSEO({
    title: "ATS IT Solutions | Technology, AI & Digital Growth Solutions for Modern Businesses",
    description:
      "ATS IT Solutions delivers IT consulting, custom software, cloud, AI & automation, DevOps, cybersecurity, managed IT and digital marketing & growth — helping businesses build, modernize, automate, secure and scale.",
  });

  return (
    <div data-testid="home-page">
      <Hero />
      <Stats />
      <Services />
      <WhyChoose />
      <TechStack />
      <Process />
      <Industries />
      <Work />
      <AISpotlight />
      <Leadership />
      <Testimonials />
      <ContactCTA />
    </div>
  );
}
